import { ImportStatusEnum } from '@/types'
import type { BadgeVariants } from '@/ui'

export const IMPORT_STATUS_COLORS: Record<ImportStatusEnum, BadgeVariants['variant']> = {
  [ImportStatusEnum.PENDING]: 'yellow',
  [ImportStatusEnum.READY]: 'lime',
  [ImportStatusEnum.PROCESSING]: 'orange',
  [ImportStatusEnum.QUEUED]: 'orange',
  [ImportStatusEnum.COMPLETED]: 'green',
  [ImportStatusEnum.FAILED]: 'red',
}
